import React from 'react';
import { XIcon, HomeIcon, MapPinIcon, ClipboardListIcon, BarChart3Icon, ShieldIcon, UserIcon, SettingsIcon, LogOutIcon, BellRingIcon } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { useApp } from '../../contexts/AppContext';
import { wardNames } from '../../data/checklists';
interface HamburgerMenuProps {
  isOpen: boolean;
  onClose: () => void;
  onNavigate: (page: string) => void;
}
export function HamburgerMenu({
  isOpen,
  onClose,
  onNavigate
}: HamburgerMenuProps) {
  const {
    colors
  } = useTheme();
  const {
    currentWard,
    user,
    logout
  } = useApp();
  const menuItems = [{
    id: 'home',
    label: 'Home',
    icon: HomeIcon
  }, {
    id: 'switch-ward',
    label: 'Switch Ward',
    icon: MapPinIcon,
    subtitle: wardNames[currentWard]
  }, {
    id: 'checklists',
    label: 'Checklists',
    icon: ClipboardListIcon
  }, {
    id: 'reports',
    label: 'Reports',
    icon: BarChart3Icon
  }, {
    id: 'staff-buzzer',
    label: 'Staff Buzzer 📳',
    icon: BellRingIcon
  }, {
    id: 'ipc-officer',
    label: 'IPC Officer',
    icon: ShieldIcon,
    locked: true
  }, {
    id: 'settings',
    label: 'Settings',
    icon: SettingsIcon
  }];
  const handleItemClick = (id: string) => {
    onNavigate(id);
    onClose();
  };
  const handleLogout = () => {
    logout();
    onClose();
  };
  if (!isOpen) return null;
  return <>
      <div className="fixed inset-0 z-40" style={{
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    }} onClick={onClose} data-id="element-46" />
      <div className="fixed top-0 left-0 bottom-0 w-80 z-50 overflow-y-auto" style={{
      backgroundColor: colors.cardSurface
    }} data-id="element-47">
        <div className="flex items-center justify-between p-4 border-b" style={{
        borderColor: colors.divider
      }} data-id="element-48">
          <button onClick={() => handleItemClick('profile')} className="flex items-center gap-3 flex-1" data-id="element-49">
            <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{
            backgroundColor: colors.accent
          }} data-id="element-50">
              <UserIcon size={24} color="#FFFFFF" data-id="element-51" />
            </div>
            <div className="text-left" data-id="element-52">
              <p className="font-bold" style={{
              color: colors.textPrimary
            }} data-id="element-53">
                {user?.name}
              </p>
              <p className="text-sm" style={{
              color: colors.textSecondary
            }} data-id="element-54">
                View Profile
              </p>
            </div>
          </button>
          <button onClick={onClose} className="p-2 rounded-lg transition-colors" style={{
          color: colors.textPrimary
        }} aria-label="Close menu" data-id="element-55">
            <XIcon size={24} data-id="element-56" />
          </button>
        </div>
        <div className="p-2" data-id="element-57">
          {menuItems.map(item => {
          const Icon = item.icon;
          return <button key={item.id} onClick={() => handleItemClick(item.id)} className="w-full flex items-center gap-3 p-4 rounded-lg transition-colors text-left" style={{
            color: colors.textPrimary
          }} data-id="element-58">
                <Icon size={24} style={{
              color: colors.accent
            }} data-id="element-59" />
                <div className="flex-1" data-id="element-60">
                  <div className="flex items-center gap-2" data-id="element-61">
                    <span className="font-medium" data-id="element-62">{item.label}</span>
                    {item.locked && <span className="text-xs px-2 py-0.5 rounded" style={{
                  backgroundColor: colors.warning + '20',
                  color: colors.warning
                }} data-id="element-63">
                        Locked
                      </span>}
                  </div>
                  {item.subtitle && <span className="text-sm opacity-60" data-id="element-64">{item.subtitle}</span>}
                </div>
              </button>;
        })}
          <button onClick={handleLogout} className="w-full flex items-center gap-3 p-4 rounded-lg transition-colors text-left mt-4" style={{
          color: colors.error,
          borderTop: `1px solid ${colors.divider}`
        }} data-id="element-65">
            <LogOutIcon size={24} data-id="element-66" />
            <span className="font-medium" data-id="element-67">Logout</span>
          </button>
        </div>
      </div>
    </>;
}